<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    title="Signature en cours"
    class="!max-w-[720px]">
    <template v-slot:modalBody>
      <div
        class="flex flex-col gap-[12px]"
        v-if="props.contrat?.lancement">
        La procédure de signature a été déclenchée le
        {{ props.contrat?.lancement.createdDate }}. Un mail a été envoyé à
        l'adresse {{ props.formateur.email }}.<br /><br />
        Pour annuler la procédure, cliquez sur "Annuler la signature en cours"
        (cette action est irréversible).
      </div>
    </template>
    <template v-slot:modalFooter>
      <refonte-button
        variant="secondary"
        v-bind:on_click="props.on_close">
        Fermer
      </refonte-button>
      <refonte-button
        variant="primary"
        v-bind:on_click="cancel">
        Annuler la signature en cours
      </refonte-button>
    </template>
  </refonte-modal>
  <refonte-modal-file-signature-details-in-progress-confirmation
    v-bind:show="isConfirmationQuestionModalOpen"
    v-bind:on_close="closeConfirmationQuestionModalOpen"
    v-bind:on_submit="submit" />
  <refonte-modal-confirmation-action
    v-bind:show="isConfirmationActionDoneModalOpen"
    v-bind:on_close="closeConfirmationActionDoneModal"
    title=""
    content="La procédure de signature a été annulée avec succès." />
  <refonte-modal-file-signature-details-maintenance
    v-bind:show="isSignatureMaintenanceModalOpen"
    v-bind:on_close="() => setIsSignatureMaintenanceModalOpen(false)"
    v-bind:convention="props.contrat" />
  <refonte-modal-confirmation-action
    v-bind:show="isErrorModalOpen"
    v-bind:on_close="closeErrorModal"
    title="Erreur lors de l'annulation de la collecte"
    content="Une erreur est survenue lors de l'annulation de la signature. Veuillez réeesayer ultérireurement ou contacter votre adminsitrateur." />
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import { ref } from 'vue';
  import RefonteModalConfirmationAction from '@/components/refonte/modals/refonte-modal-confirmation-action.vue';
  import { API } from '@/http-common';
  import RefonteModalFileSignatureDetailsInProgressConfirmation from '@/components/refonte/modals/refonte-modal-file-signature-details-in-progress-confirmation.vue';
  import RefonteModalFileSignatureDetailsMaintenance from '@/components/refonte/modals/refonte-modal-file-signature-details-maintenance.vue';
  import { FormateurContrat } from '@/types/formateur/formateur-contrat';
  import { InfoFormateurSignature } from '@/types/formateur/info-formateur-signature';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      refresh_contrats: Function;
      contrat?: FormateurContrat;
      class?: string;
      contrat_id?: number;
      formateur: InfoFormateurSignature;
    }>(),
    {
      class: ''
    }
  );
  const isErrorModalOpen = ref<boolean>(false);
  const isSignatureMaintenanceModalOpen = ref<boolean>(false);
  const setIsSignatureMaintenanceModalOpen = (value: boolean) => {
    isSignatureMaintenanceModalOpen.value = value;
  };
  const closeErrorModal = () => {
    isErrorModalOpen.value = false;
    props.on_close();
    closeConfirmationQuestionModalOpen();
  };

  const cancel = () => {
    if (props.contrat?.signatureMaintenance) {
      setIsSignatureMaintenanceModalOpen(true);
    } else {
      openConfirmationQuestionModalOpen();
    }
  };
  const annulerSignature = async () => {
    if (props.contrat?.id) {
      try {
        const response = await API.delete(
          `formateur/contrat/${props.contrat.id}/signature`,
          { headers: { 'SKIP-REDIRECTION': true } }
        );
        if (response.status == 200) {
          isConfirmationActionDoneModalOpen.value = true;
          props.refresh_contrats();
        } else {
          isErrorModalOpen.value = true;
        }
      } catch (e) {
        isErrorModalOpen.value = true;
      }
    }
  };

  const submit = async () => {
    await annulerSignature();
  };

  const isConfirmationActionDoneModalOpen = ref<boolean>(false);

  const closeConfirmationActionDoneModal = () => {
    isConfirmationActionDoneModalOpen.value = false;
    props.on_close();
    closeConfirmationQuestionModalOpen();
  };
  const isConfirmationQuestionModalOpen = ref<boolean>(false);

  const closeConfirmationQuestionModalOpen = () => {
    isConfirmationQuestionModalOpen.value = false;
  };

  const openConfirmationQuestionModalOpen = () => {
    isConfirmationQuestionModalOpen.value = true;
  };
</script>

<style lang="scss" scoped></style>
